var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6253 7.49984C10.6253 7.15466 10.3455 6.87484 10.0003 6.87484C9.65515 6.87484 9.37533 7.15466 9.37533 7.49984L9.37533 9.37486H7.50033C7.15515 9.37486 6.87533 9.65468 6.87533 9.99986C6.87533 10.345 7.15515 10.6249 7.50033 10.6249H9.37533V12.4998C9.37533 12.845 9.65515 13.1248 10.0003 13.1248C10.3455 13.1248 10.6253 12.845 10.6253 12.4998L10.6253 10.6249H12.5003C12.8455 10.6249 13.1253 10.345 13.1253 9.99986C13.1253 9.65468 12.8455 9.37486 12.5003 9.37486H10.6253V7.49984Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 1.0415C5.05277 1.0415 1.04199 5.05229 1.04199 9.99984C1.04199 14.9474 5.05277 18.9582 10.0003 18.9582C14.9479 18.9582 18.9587 14.9474 18.9587 9.99984C18.9587 5.05229 14.9479 1.0415 10.0003 1.0415ZM2.29199 9.99984C2.29199 5.74264 5.74313 2.2915 10.0003 2.2915C14.2575 2.2915 17.7087 5.74264 17.7087 9.99984C17.7087 14.257 14.2575 17.7082 10.0003 17.7082C5.74313 17.7082 2.29199 14.257 2.29199 9.99984Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/AddCircle.2a0b54bab7e2e84e4532c1b96812e12a.svg";
export { ForwardRef as ReactComponent };